module.exports = __webpack_public_path__ + "static/media/box-bottom-only.fd89389b.png";